import React from 'react';

import { Box, Text, Inline } from '@atlaskit/primitives/compiled';

import { getComponentPreviewIcon } from './componentIconMapping.tsx';

export type ComponentPreviewProps = {
	componentType: string;
	componentName: string;
};

export const ComponentPreview = ({ componentType, componentName }: ComponentPreviewProps) => {
	const Icon = getComponentPreviewIcon(componentType);
	return (
		<Box paddingBlock="space.050">
			<Inline space="space.150" alignBlock="center">
				{Icon}
				<Text align="center" size="medium">
					{componentName}
				</Text>
			</Inline>
		</Box>
	);
};
